import some from 'lodash/some.js';
import { useI18n } from 'vue-i18n';

import File from '@/components/activity-types/course-activity-types/activities/File.js';

export default {
    setup() {
        const { t: translate } = useI18n();
        return { translate };
    },
    methods: {
        filesAreValid(files) {
            return this.fileSizesAreValid(files);
        },

        alertIfOverMaxFiles(files, maxFiles) {
            if (files.length > maxFiles) {
                this.$snackbar.open({
                    message: this.translate('max_files_reached', {
                        max: maxFiles,
                        files: this.translate('file', maxFiles),
                    }),
                });
            }
        },

        fileSizesAreValid(files) {
            return !some(files, file => {
                if (file.size > this.globalMaxFileSize) {
                    this.$snackbar.open({
                        type: 'is-danger',
                        position: 'is-bottom-left',
                        queue: false,
                        message: this.translate('file_size_too_large', {
                            max: this.globalMaxFileSizeLabel,
                            name: file.name,
                        }),
                        duration: 5000,
                    });

                    return true;
                }

                return false;
            });
        },

        reduceFilesToMax(files, maxFiles) {
            return files
                .map(file => {
                    return file instanceof File ? file : new File(file);
                })
                .slice(-1 * maxFiles);
        },
    },
};
